module.exports = __webpack_public_path__ + "img/1554897282.3ae554f2.jpg";